import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { StNextImage } from '../shared/NextImage.styles';
import StErrorPageContainer from './ErrorPage.style';
import UiBox from '../../components/shared/Box';
import UiHeading from '../../components/shared/Heading';
import UiText from '../../components/shared/Typography/UiText';
import ButtonPrimary from '../../components/shared/Button/PrimaryButton';
import router from 'next/router';

const ErrorPage = (props: any): any => {
  if (!props?.fields) return <></>;

  return (
    <StErrorPageContainer sx={{ minHeight: '100%' }}>
      <Box className="content">
        <Stack spacing={5}>
          <Box display="flex" justifyContent="center">
            <StNextImage
              suppressHydrationWarning
              data-testid="icon"
              field={props.fields.icon}
              width={97}
              height={87}
            />
          </Box>

          <UiBox>
            <UiHeading size="h3" color="primary" align="center" data-testid="header">
              {props.fields.content}
            </UiHeading>
          </UiBox>

          <Grid>
            <UiText size="body" color="black" className="sub-content" data-testid="sub-header">
              <Text field={props.fields.subContent} />
            </UiText>
          </Grid>

          <Box className="back-btn">
            <ButtonPrimary
              role="button"
              data-testid="back-button"
              aria-label={props?.fields?.ariaLabel?.value}
              onClick={() => router.push('/en')}
            >
              {props?.fields?.link?.value?.text}
            </ButtonPrimary>
          </Box>
        </Stack>
      </Box>
    </StErrorPageContainer>
  );
};

export default ErrorPage;
